<div *ngIf="showToaster" class="toast-container position-fixed top-0 start-50 translate-middle-x mt-3"
    style="z-index: 9999">
    <div class="toast-wrapper col-11 col-md-8 col-lg-5">
        <div class="toast show bg-success text-white p-3 rounded-pill shadow-lg w-100" role="alert"
            aria-live="assertive" aria-atomic="true">

            <div class="d-flex align-items-center">

                <fa-icon [icon]="faCheckCircle"></fa-icon>

                <div class="flex-grow-1 text-center me-2">
                    <span class="fw-semibold">{{ title }}</span>
                </div>

                <button type="button" class="btn-close btn-close-white ms-auto mt-0 flex-shrink-0" aria-label="Close"
                    (click)="closeToast()"></button>
            </div>

        </div>
    </div>
</div>